import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Loading from 'components/common/loading-component';

const LOADING_OVERLAY = 'loading-overlay';
/**
 * Generic Loading Overlay component that displays a full-screen overlay with loading spinner and optional message
 * @param {Object} props - Component props
 * @param {boolean} props.isVisible - Whether the overlay is visible
 * @param {string} props.message - Optional loading message to display
 * @param {number} props.zIndex - Z-index value for the overlay (default: 9999)
 * @param {string} props.backgroundColor - Background color of the overlay (default: '#00000080')
 * @param {string} props.cursor - Cursor style (default: 'wait')
 * @param {Object} props.customStyles - Additional custom styles for the overlay
 * @param {Object} props.messageStyles - Additional custom styles for the message
 * @param {string} props.id - Optional ID for the overlay div
 */
const LoadingOverlay = ({
  isVisible = false,
  message = '',
  zIndex = 9999,
  backgroundColor = '#00000080',
  cursor = 'wait',
  customStyles = {},
  messageStyles = {},
  id = 'loadingOverlay',
}) => {
  if (!isVisible) {
    return null;
  }

  const overlayStyles = {
    background: backgroundColor,
    zIndex: zIndex,
    cursor: cursor,
    ...customStyles,
  };

  const defaultMessageStyles = {
    ...messageStyles,
  };

  return (
    <div style={overlayStyles} className={LOADING_OVERLAY} id={id}>
      {message && (
        <div
          className={`${LOADING_OVERLAY}__message`}
          style={defaultMessageStyles}
        >
          <FormattedMessage id={message} />
        </div>
      )}
      <Loading />
    </div>
  );
};

LoadingOverlay.propTypes = {
  isVisible: PropTypes.bool,
  message: PropTypes.string, // Translation key for FormattedMessage
  zIndex: PropTypes.number,
  backgroundColor: PropTypes.string,
  cursor: PropTypes.string,
  customStyles: PropTypes.object,
  messageStyles: PropTypes.object,
  id: PropTypes.string,
};

export default LoadingOverlay;
